import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 * My information correction service
 * !== 나의 정보 수정 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/mypage/myinfochg`,
    api_myinfo: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/mypage/myinfo`,
    api_acrbt: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/acrdt`,
    api_ofcr: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/usr/cstm-ofcrs`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0205002q: `${BASE.path}/ptli0205002q`, // !== 결재요청팝업 ==!
    ptli0205003q: `${BASE.path}/ptli0205003q`, // !== 결재자 선택 팝업 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Search user registration application information based on login ID !== 로그인ID 기준 사용자 등록 신청 정보 조회==!
    getMyInfo: (data: any) =>
        api.get(`${BASE.api_myinfo}/${data.usrDmnId}`, { params: comnUtils.toGetParams({ aprvId: data.aprvId }) }),

    // Section search by customs, unit search by section !== 세관별 섹션 조회, 섹션별 유닛 조회 ==!
    getOrgzList: (data: any) => {
        return api.get(`${BASE.api_acrbt}/new-usr/myInfo/orgz?`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Save User Information !== 사용자 정보 저장 ==!
    saveMyInfo: (data: any) => {
        return api.post(`${BASE.api_myinfo}`, {
            ...data,
        });
    },
    // Save user application information and modify user information !== 사용자 신청 정보 저장 및 사용자 정보 수정 ==!
    saveUsrRgsrAply: (data: any) => {
        return api.post(`${BASE.api_myinfo}/aply/new`, {
            ...data,
        });
    },

    // Save payment ID in user application information !== 사용자 신청 정보에 결재 ID를 저장한다 ==!
    saveUsrAplyId: (data: any) => {
        return api.post(`${BASE.api_acrbt}/usr-aprv-id/myInfo`, {
            ...data,
        });
    },

    // Get a list of Customs Role. !== 세관 역할 목록을 조회한다. ==!
    getCstmRoleList: (data: any) => {
        return api.get(`${BASE.api_ofcr}/roles/myInfo?`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // !== 섹션매니저와 결재자 목록을 조회한다. ==!
    getAprvUsrList: (data: any) => {
        return api.get(`${BASE.api_acrbt}/aprv-usr/myInfo?`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Get Section manager Y/N !== 섹션매니저 여부 조회 ==!
    getSctnMngrYn: (roleId: any) => api.get(`${BASE.api_acrbt}/sctn-mngr/myInfo/${roleId}`),
};

export const SF_MY_INFO_CHG_INFO: TFormSchema = {
    id: "form_myInfoChg",
    schema: {
        fileGrpUuid: {
            type: "file",
            label: "L_CSTM_OFCR_PHTO",
            thumbnail: true,
            thumbnailWidth: 100,
            thumbnailHeight: 130,
            isPublic: true,
        },
        usrPhtoFileUuid: { type: "text", label: "L_CSTM_OFCR_PHTO" },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO", maxLength: 10 },
        usrDmnId: { type: "text", label: "L_USR_ID" },
        intUsrAplyId: { type: "text" },
        aprvPrcssStatCdNm: { type: "text", label: "L_PRCSS_STTS", edit: false },
        aprvPrcssOpinCn: { type: "text", label: "L_APRV_PRCS_OPIN_CN", edit: false },
        usrNm: { type: "text", label: "L_CSTM_OFCR_NAME" },
        usrTelno: {
            type: "text",
            pattern: { value: /[0-9]$/, message: "msg.ptl.00677" },
            label: "L_CSTM_OFCR_TEL_NO",
        },
        usrTin: { type: "text", label: "L_TIN", maxLength: 9 },
        usrEmlAddr: { type: "text", label: "L_CSTM_OFCR_EML" },
        usrPwd: {
            type: "password",
            label: "L_PWD",
            pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/,
                message: "msg.ptl.00761",
            },
        },
        usrPwdCfrm: { type: "password", label: "L_PWD_CFRM" },
        cstmOfceCd: { type: "code", label: "L_CSTM_OFCE", area: "cstmCd" },
        cstmSctnOrgzCd: {
            type: "code",
            area: "orgzSub",
            label: "L_CSTM_SCTN",
            popupSize: "md",
        },
        cstmUnitOrgzCd: { type: "select", label: "L_CSTM_UNIT" },
        roleId: { type: "select", label: "L_ROLE_NM" },
        roleNm: { type: "text", label: "L_ROLE_NM" },
        actnUsrYn: {
            type: "radio",
            label: "L_BIDR",
            options: [
                { label: "L_CD_YES", value: "Y" },
                { label: "L_CD_NO", value: "N" },
            ],
            viewType: "label",
            defaultValue: "N",
        },
        cstmOfceCdNm: { type: "text", label: "L_CSTM_OFCE" },
        cstmSctnOrgzCdNm: { type: "text", label: "L_CSTM_SCTN" },
        cstmUnitOrgzCdNm: { type: "text", label: "L_CSTM_UNIT" },
    },
};
